// extracted by mini-css-extract-plugin
export default {"collapseItem":"Collapse_collapseItem__+flO9","collapseHeader":"Collapse_collapseHeader__a63Tc"};